<template lang="pug">
tr(data-test-id="non-scheduled-product-row")
  td(:class="{ indent: belongsToDeal }")
    // data-test-id will be set on the multiselect within BriqMultiselect because of v-bind="attrs"
    BriqMultiselect(
      v-model="internalProductKey"
      :options="productOptions"
      display="NameInternal"
      track-by="Key"
      :disabled="belongsToDeal"
      :data-test-id="dataTestId"
      )
      template(slot="singleLabel" slot-scope="props")
        BriqMultiselectCustomLabel(
          :label="props.option.NameInternal"
          :shouldShowWarning="shouldShowWarning"
          :warningLabel="productWarningLabel"
          )
      template(slot="option" slot-scope="props" )
        div {{ props.option.NameInternal }}
    .product-type {{ productType(bookingProduct.DealProductType) }}
  td.quantity-col
    BookingProductQuantityPicker(
      :bookingProduct="bookingProduct"
      :belongsToDeal="belongsToDeal"
      :disabled="belongsToDeal"
      )
  td.delete-col(style="width: 59px;")
    TrashIconButton(v-if="!belongsToDeal" @delete="$emit('delete', bookingProduct)")
</template>

<script>
import { filter, prop, pipe, map, pick } from 'ramda'
import TrashIconButton from '@v/bookings/edit/components/TrashIconButton.vue'
import BookingProductQuantityPicker from '@v/bookings/edit/components/BookingProductQuantityPicker.vue'
import BriqMultiselectCustomLabel from '@v/bookings/edit/UpsertBooking/BriqMultiselectCustomLabel'
import { maybeAppendBookingProduct } from '@v/bookings/edit/util/maybeAppendBookingProduct.js'
import DealProductType from '@v/bookings/edit/models/DealProductType.js'

export default {
  name: 'NonScheduledProductsTableRow',
  components: { TrashIconButton, BookingProductQuantityPicker, BriqMultiselectCustomLabel },
  props: {
    bookingProduct: { type: Object, required: true },
    nonScheduledProductOptions: { type: Array, required: true },
    classifications: Array,
  },
  computed: {
    internalProductKey: {
      get() {
        return this.bookingProduct?.ProductKey
      },
      set(newProductKey) {
        if (newProductKey)
          this.$emit('switchNonScheduledProduct', {
            oldBookingProduct: this.bookingProduct,
            newProductKey,
          })
      },
    },
    productOptions() {
      const filterProducts = filter(prop('Enabled'))
      return pipe(
        filterProducts,
        map(pick(['Key', 'NameInternal'])),
        maybeAppendBookingProduct(this.bookingProduct),
      )(this.nonScheduledProductOptions)
    },
    dataTestId() {
      return 'nonscheduled-select-' + this.bookingProduct.ResourceKey
    },
    belongsToDeal() {
      return (
        !!this.bookingProduct.ProductGroupKey &&
        this.bookingProduct.DealProductType === DealProductType.DealProduct
      )
    },
    shouldShowWarning() {
      return (
        this.bookingProduct.ProductActiveState &&
        this.bookingProduct.ProductActiveState !== 'Active'
      )
    },
    productWarningLabel() {
      return this.shouldShowWarning ? this.bookingProduct.ProductActiveState.toLowerCase() : null
    },
  },
  methods: {
    productType(dealProductType) {
      switch (dealProductType) {
        case DealProductType.DealProduct:
          return 'Base product'
        case DealProductType.CrossSell:
          return 'Extra product'
        case DealProductType.NotSet:
          return ''
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.indent
  padding-left 48px

.quantity-col
  width 513px

.delete-col
  width 59px

.product-type
  font-size 12px
  line-height 16px
  color #4E5A6A
  margin-top 6px
</style>
